// src/store.js
import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
import { loadState } from './reducers/localStorage';
import { normalizeYearSettings } from './helpers/year';

const enhancers = [];
const persistedState = loadState();
const middleware = [thunk];

if (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const sanitizedState = persistedState
  ? {
      ...persistedState,
      settingsReducer: normalizeYearSettings(persistedState.settingsReducer),
    }
  : persistedState;

const store = createStore(rootReducer, sanitizedState, composedEnhancers);

export default store;
